import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { PageLoader } from "@codestack/ui";
import { AdminLayout } from "./components/AdminLayout";
import { RequirePermission } from "./components/RequirePermission";
import { useAuth } from "./lib/auth";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { TransactionsPage } from "./pages/TransactionsPage";
import { TransactionDetailPage } from "./pages/TransactionDetailPage";
import { PlatformsPage } from "./pages/PlatformsPage";
import { PlatformDetailPage } from "./pages/PlatformDetailPage";
import { RevenuePage } from "./pages/RevenuePage";
import { ReconciliationPage } from "./pages/ReconciliationPage";
import { AuditPage } from "./pages/AuditPage";
import { HealthPage } from "./pages/HealthPage";
import { TeamPage } from "./pages/TeamPage";
import { RolesPage } from "./pages/RolesPage";
import { SettingsPage } from "./pages/SettingsPage";
import { UpdatesPage } from "./pages/UpdatesPage";

function ProtectedLayout() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="grid min-h-screen place-items-center">
        <PageLoader label="Restoring your session…" />
      </div>
    );
  }

  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <AdminLayout />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedLayout />}>
        <Route index element={<DashboardPage />} />

        <Route
          path="transactions"
          element={
            <RequirePermission permission="transaction:read">
              <TransactionsPage />
            </RequirePermission>
          }
        />
        <Route
          path="transactions/:id"
          element={
            <RequirePermission permission="transaction:read">
              <TransactionDetailPage />
            </RequirePermission>
          }
        />

        <Route
          path="platforms"
          element={
            <RequirePermission permission="platform:read">
              <PlatformsPage />
            </RequirePermission>
          }
        />
        <Route
          path="platforms/:id"
          element={
            <RequirePermission permission="platform:read">
              <PlatformDetailPage />
            </RequirePermission>
          }
        />

        <Route
          path="revenue"
          element={
            <RequirePermission permission="report:read">
              <RevenuePage />
            </RequirePermission>
          }
        />

        <Route
          path="reconciliation"
          element={
            <RequirePermission permission="reconciliation:run">
              <ReconciliationPage />
            </RequirePermission>
          }
        />
        <Route
          path="audit"
          element={
            <RequirePermission permission="audit:read">
              <AuditPage />
            </RequirePermission>
          }
        />
        <Route path="health" element={<HealthPage />} />

        <Route
          path="team"
          element={
            <RequirePermission permission="user:manage">
              <TeamPage />
            </RequirePermission>
          }
        />
        <Route
          path="roles"
          element={
            <RequirePermission permission="role:manage">
              <RolesPage />
            </RequirePermission>
          }
        />
        <Route
          path="updates"
          element={
            <RequirePermission permission="content:manage">
              <UpdatesPage />
            </RequirePermission>
          }
        />
        <Route
          path="settings"
          element={
            <RequirePermission permission="settings:manage">
              <SettingsPage />
            </RequirePermission>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
